import React from "react";
import OfficeCard from "../OfficeCard/OfficeCard.jsx";

const DynamicOfficeCard = ({
  title,
  offices = [],
  isAgencyVerification = false,
  showBadgeText = true,
  addressLabel,
  underwriterLabel,
  serviceStateLabel,
  officeType,
  phoneLabel,
  faxLabel,
  mapLabel,
  detailsLabel,  
}) => {
  const sortedOffices = [...offices].sort((a, b) => {
    const aOwned = String(a.StewartOwned) === "true";
    const bOwned = String(b.StewartOwned) === "true";

    if (aOwned && !bOwned) return -1;
    if (!aOwned && bOwned) return 1;
    return 0;
  });

  return (
    <div className="dynamic-office">
      {title && <h2 className="dynamic-office__title">{title}</h2>}
      <div className="dynamic-office__grid">
        {sortedOffices.map(office => {
          const details = office.details ?? {
            title: `${office.OfficeCompanyName}`,
            mailingAddress: {
              street: office.OfficeAddress?.Address1 || "",
              street2: office.OfficeAddress?.Address2 || "",
              city: office.OfficeAddress?.City || "",
              state: office.OfficeAddress?.State || "",
              zip: office.OfficeAddress?.Zip || "",
            },
            phone: office.Phone,
            fax: office.Fax,
            distance: office.Distance,
            stewartOwned: office.StewartOwned === "true",
            lat: office.Latitude,
            lng: office.Longitude,
          };
          const detailsLink = office.URL;

          return (
            <OfficeCard
              key={office.AgentID}
              agentType={office.AgentType}
              details={details}
              detailsLink={detailsLink}
              showBadgeText={showBadgeText}
              isAgencyVerification={isAgencyVerification}
              underwriterCode={office.UnderwriterCode ?? ""}
              serviceState={office.ServiceState ?? ""}
              addressLabel={addressLabel}
              underwriterLabel={underwriterLabel}
              serviceStateLabel={serviceStateLabel}
              officeType={officeType}
              phoneLabel={phoneLabel}
              faxLabel={faxLabel}
              mapLabel={mapLabel}
              detailsLabel={detailsLabel}
            />
          );
        })}
      </div>
    </div>
  );
};

export default DynamicOfficeCard;
